// src/lib/telegram.ts

export function normalizeTelegramHandle(handle: string): string {
  const raw = String(handle ?? "").trim();
  if (!raw) return "";
  return raw.startsWith("@") ? raw.slice(1) : raw;
}

export function telegramChatUrl(handle: string): string {
  const normalized = normalizeTelegramHandle(handle);
  if (!normalized) return "https://t.me/";
  return `https://t.me/${encodeURIComponent(normalized)}`;
}